import React, { useEffect } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import FilteredStopMarkers from './map/FilteredStopMarkers';
import UserLocationMarker from './map/UserLocationMarker';

// 🔧 Helper component to apply dynamic zoom
const SetDynamicZoom = ({ center, distance }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !center) return;

    const getZoom = (distance) => {
      if (distance <= 1) return 15;
      if (distance > 1 && distance <= 5) return 14;
      if (distance > 5 && distance <= 20) return 13;
      if (distance > 20 && distance <= 50) return 12;
      return 15;
    };

    const zoom = getZoom(distance);
    map.setView(center, zoom);
  }, [center, distance, map]);

  return null;
};

function MapView({ userLocation, filteredStops, distanceFilter = 1, overlappingStops }) {
  const center = userLocation;
  console.log("overlapping stops", overlappingStops)
  return (
    <MapContainer
      center={center}
      zoom={15} // Initial zoom (will be updated)
      style={{ height: '90vh', width: '100%' }}
    >
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://carto.com/">CARTO</a> contributors'
      />
      <UserLocationMarker position={center} />
      <FilteredStopMarkers stops={filteredStops} userLocation={userLocation} overlappingStops={overlappingStops} />
      <SetDynamicZoom center={center} distance={distanceFilter} />
    </MapContainer>
  );
}

export default MapView;
